

export default {
    head() {
        return {
            title: `${this.infoGenerales?.attributes?.mentionsLegalesTitle}`,
            meta: this.infoGenerales?.attributes?.mentionsLegalesMeta != null && this.infoGenerales?.attributes?.mentionsLegalesMeta != undefined ?
                JSON.parse(this.infoGenerales?.attributes?.mentionsLegalesMeta?.replace('\n', '')) : null
        };
        // return {
        //     title: `ICFA - Mentions Légales`,
        //     meta: [
        //         {
        //             hid: 'og-title',
        //             property: 'og:title',
        //             content: 'Mentions Légales',
        //         },
        //         // {
        //         //     hid: 'og-description',
        //         //     property: 'og:description',
        //         //     content: `Vous avez des questions sur nos formations en alternance? Contactez l'ICFA pour des conseils d'experts et des informations détaillées. Votre future carrière commence ici.`,
        //         // }
        //     ]
        // };
    },
    async asyncData({ params, store }) {
        let instances = store.state.instances;
        let infoGenerales = JSON.parse(JSON.stringify(store.state.infoGenerales));


        return {
            params, instances, infoGenerales
        }
    },
}



